import { get } from "lodash";
import { observable, computed, action } from "mobx";
import { teamStore } from "../app/stores";
import { firebase } from "../app/constants";

class AuthStore {
  @observable token = null;
  @observable userAuth = null;
  @observable userData = null;
  @observable initialized = false;
  @observable authenticated = false;
  @observable authenticating = false;

  @computed
  get userId() {
    return get(this.userData, "user.id", null);
  }
  @computed
  get scUserId() {
    const scUsers = get(teamStore, "team.scUsers", {});
    return Object.keys(scUsers).find(
      (key) => scUsers[key].slackUserId == this.userId
    );
  }
  @computed
  get userImg() {
    return get(this.userData, "user.profile.image_72");
  }
  @computed
  get userName() {
    return get(this.userData, "user.profile.real_name", null);
  }
  @computed
  get currentUser() {
    return firebase.auth().currentUser;
  }

  @action.bound
  loadUserData(userId) {
    firebase
      .database()
      .ref(`slackUserData/${userId}`)
      .on(
        "value",
        action((snap) => {
          this.userData = snap.val();
          // configure support widget
          // inception line right here
          if (window.Smallchat && window.Smallchat.set) {
            this.setSessionData();
          } else {
            window.addEventListener("smallchat:ready", this.setSessionData);
          }
        })
      );
  }

  @action.bound
  loadUser(user) {
    if (this.initialized) {
      return;
    }
    this.initialized = true;
    this.authenticated = true;
    firebase
      .database()
      .ref(`scUser/${user.uid}`)
      .once(
        "value",
        action((snap) => {
          this.userAuth = snap.val();
          this.loadUserData(this.userAuth.slackData.user_id);
          teamStore.listenToTeam(this.userAuth.slackData.team_id);
        })
      );
  }

  @action.bound
  signInWithToken(token) {
    firebase
      .auth()
      .signInWithCustomToken(token)
      .then(
        action((user) => {
          this.loadUser(user);

          //Clear out the token once we use it, or else this tab will try to re-log-in with the token
          //if the app is logged out from another tab.
          this.token = null;
        })
      )
      .catch(
        action((err) => {
          this.error = err;
        })
      );
  }

  @action.bound
  listenToAuth() {
    this.authenticating = true;
    firebase.auth().onAuthStateChanged(
      action((user) => {
        this.authenticating = false;
        if (user) {
          this.loadUser(user);
        } else if (this.token) {
          this.signInWithToken(this.token);
        } else {
          this.authenticated = false;
        }
      })
    );
  }

  @action.bound
  setAuthToken(token) {
    this.token = token;
  }

  @action.bound
  logout() {
    firebase
      .auth()
      .signOut()
      .then(
        action(() => {
          console.log("success");
          this.user = null;
          this.token = null;
          this.initialized = false;
          this.authenticated = false;
          this.authenticating = false;
        })
      )
      .catch(
        action((err) => {
          console.log("failure", err);
        })
      );
  }

  setSessionData() {
    if (window.Smallchat && window.Smallchat.set) {
      const profile = get(this.userData, "user.profile", {});
      window.Smallchat.set("name", profile.real_name);
      window.Smallchat.set("email", profile.email);
      window.Smallchat.set("team", teamStore.teamName);
      window.Smallchat.set("domain", teamStore.teamDomain);
    }
  }
}

const authStore = new AuthStore();

export default authStore;



// WEBPACK FOOTER //
// ./src/auth/auth-store.js